export default __webpack_public_path__ + "static/media/medal-group-new.708c0736.svg";